import AppsComponent from "../components/Online/AppsComponent";
import {useAuthStore} from "../store/user-store";
import {useEffect, useRef} from "react";

export default function AboutPage(){
    const authStore = useAuthStore();
    const contentRef = useRef(null);

    useEffect(() => {
        // Function to process the content after it's rendered
        const processContent = () => {
            if (contentRef.current) {
                // Remove all figcaption elements
                const figcaptions = contentRef.current.getElementsByTagName('figcaption');
                // Convert HTMLCollection to array before using forEach
                Array.from(figcaptions).forEach(caption => {
                    caption.remove();
                });
                
                // Set width and height for all images
                const images = contentRef.current.getElementsByTagName('img');
                Array.from(images).forEach(img => {
                    img.width = 300;
                    img.height = 200;
                });
            }
        };

        // Process content immediately in case it's already rendered
        processContent();
        
        // Set up a MutationObserver to watch for changes in the content
        const observer = new MutationObserver(processContent);
        
        // Start observing the content container
        if (contentRef.current) {
            observer.observe(contentRef.current, {
                childList: true,
                subtree: true
            });
        }

        // Clean up the observer on component unmount
        return () => observer.disconnect();
    }, []);

    return (
        <>
            <h1 className={'text-danger text-center mb-4'} style={{textDecoration: 'underline'}}>من نحن</h1>
            <div 
                ref={contentRef}
                className={'text-white text-center px-2'}
                dangerouslySetInnerHTML={{__html: authStore.settings?.about}}
            />
        </>
    )
}